module.exports = __webpack_public_path__ + "img/pay-success-btn@2x.a985355a.png";